import {IComponentOptions, IFilterService, ILogService} from 'angular';
import {ApplicationPropertyRS} from '../../../admin/service/applicationPropertyRS.rest';
import {getKantonCodeList, TSKantonCode} from '../../../models/enums/TSKantonCode';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSInspektorat from '../../../models/TSInspektorat';
import RoleUtilService from '../../service/RoleUtilService';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-inspektorat-list.html');
require('./dv-inspektorat-list.scss');

export class DVInspektoratListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        inspektorat: '=',
        itemsByPage: '<',
        onEdit: '&',
    };
    template = template;
    controller = DVInspektoratListController;
    controllerAs = 'vm';
}

export class DVInspektoratListController {

    itemsByPage: number;
    inspektorat: Array<TSInspektorat> = []; //Liste die im Gui angezeigt wird
    pagination: any;
    onEdit: (paramObj: any) => void;
    selectedKanton: TSKantonCode;

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate', 'ApplicationPropertyRS'];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService, private $translate: ITranslateService, private applicationPropertyRS: ApplicationPropertyRS,
    ) {
        this.initViewModel();
    }

    private initViewModel() {
    }

    $onInit() {

    }

    public getFilterroles(): Array<TSRole> {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();
    }

    editClicked(inspektoratToEdit: any, event: any) {
        this.onEdit({inspektorat: inspektoratToEdit, event: event});
    }

    public translateAktiv(inaktiv: boolean): string {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));

    }

    public translateRoles(roles: Array<TSRole>): string {
        let prefix = rolePrefix();
        return roles.map((element) => {
            return this.$translate.instant(prefix + TSRole[element])
        }).join(', ');

    }

    public translateRole(role: TSRole): string {
        let prefix = rolePrefix();
        return this.$translate.instant(prefix + TSRole[role])

    }

    public getColumnsNumber(): number {

        let element = angular.element('.dv-inspektorat-list .header-row').first();
        if (element) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 12;
    }

    /**
     * Alle TSKantonCode fuer das Filterdropdown
     * @returns {Array<key: string; code: TSKantonCode>}
     */
    public getKantone(): { key: string; code: TSKantonCode }[] {
        let kantonCodes: TSKantonCode[] = getKantonCodeList();
        let kantonNamesAndCodes: {
            key: string
            code: TSKantonCode
        }[] = [];

        kantonCodes.forEach(code => {
            kantonNamesAndCodes.push({
                key: this.$translate.instant(code.toString()),
                code: code,
            });
        });

        kantonNamesAndCodes.sort((a, b) => a.code.toString().localeCompare(b.code.toString()));

        return kantonNamesAndCodes;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-inspektorat-list/dv-inspektorat-list.ts